import React from 'react';
import classNames from 'classnames';
import { ArticleBlock } from './ArticleBlock';
import { ErrorBoundary } from '@benzinga/core-ui';
import { ArticleBlock as ArticleBlockType } from '@benzinga/article-manager';
import styles from './ArticleBlocks.module.scss';

export interface ArticleBlocksProps {
  blocks: ArticleBlockType[];
}

export const BlocksWrapper: React.FC<React.PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <div className={classNames(styles.wrapper, className)}>{children}</div>
);

export const ArticleBlocks: React.FC<ArticleBlocksProps> = ({ blocks }) => {
  return (
    <BlocksWrapper>
      {Array.isArray(blocks) &&
        blocks.map((block: ArticleBlockType, i: number) => {
          if (!block) return null;

          return (
            <ErrorBoundary
              key={`article-blocks-item-wrapper${block?.blockName}-${i}`}
              name={`article-block-${block?.blockName}-${i}`}
            >
              <ArticleBlock block={block} />
            </ErrorBoundary>
          );
        })}
    </BlocksWrapper>
  );
};
